export const COUNTRIES = [
  { code: 'US', name: 'United States', shipping: 0, days: '3–5 business days' },
  { code: 'AL', name: 'Albania', shipping: 18.99, days: '12–20 business days' },
  { code: 'DZ', name: 'Algeria', shipping: 20.99, days: '14–22 business days' },
  { code: 'AD', name: 'Andorra', shipping: 16.99, days: '10–16 business days' },
  { code: 'AR', name: 'Argentina', shipping: 16.99, days: '12–20 business days' },
  { code: 'AM', name: 'Armenia', shipping: 19.99, days: '14–22 business days' },
  { code: 'AU', name: 'Australia', shipping: 14.99, days: '8–14 business days' },
  { code: 'AT', name: 'Austria', shipping: 12.99, days: '7–14 business days' },
  { code: 'AZ', name: 'Azerbaijan', shipping: 19.99, days: '14–22 business days' },
  { code: 'BS', name: 'Bahamas', shipping: 12.99, days: '7–12 business days' },
  { code: 'BH', name: 'Bahrain', shipping: 17.99, days: '10–18 business days' },
  { code: 'BB', name: 'Barbados', shipping: 13.99, days: '8–14 business days' },
  { code: 'BY', name: 'Belarus', shipping: 18.99, days: '14–20 business days' },
  { code: 'BE', name: 'Belgium', shipping: 12.99, days: '7–14 business days' },
  { code: 'BZ', name: 'Belize', shipping: 13.99, days: '8–14 business days' },
  { code: 'BT', name: 'Bhutan', shipping: 21.99, days: '16–25 business days' },
  { code: 'BO', name: 'Bolivia', shipping: 17.99, days: '12–20 business days' },
  { code: 'BA', name: 'Bosnia and Herzegovina', shipping: 17.99, days: '12–20 business days' },
  { code: 'BW', name: 'Botswana', shipping: 20.99, days: '14–22 business days' },
  { code: 'BR', name: 'Brazil', shipping: 16.99, days: '12–20 business days' },
  { code: 'BN', name: 'Brunei', shipping: 17.99, days: '10–18 business days' },
  { code: 'BG', name: 'Bulgaria', shipping: 14.99, days: '9–16 business days' },
  { code: 'CV', name: 'Cabo Verde', shipping: 20.99, days: '14–22 business days' },
  { code: 'CA', name: 'Canada', shipping: 8.99, days: '5–9 business days' },
  { code: 'CL', name: 'Chile', shipping: 15.99, days: '10–18 business days' },
  { code: 'CN', name: 'China', shipping: 14.99, days: '10–18 business days' },
  { code: 'CO', name: 'Colombia', shipping: 15.99, days: '10–18 business days' },
  { code: 'CR', name: 'Costa Rica', shipping: 13.99, days: '8–14 business days' },
  { code: 'HR', name: 'Croatia', shipping: 14.99, days: '9–16 business days' },
  { code: 'CY', name: 'Cyprus', shipping: 15.99, days: '10–18 business days' },
  { code: 'CZ', name: 'Czech Republic', shipping: 13.99, days: '8–14 business days' },
  { code: 'DK', name: 'Denmark', shipping: 13.99, days: '8–14 business days' },
  { code: 'DJ', name: 'Djibouti', shipping: 22.99, days: '16–25 business days' },
  { code: 'DO', name: 'Dominican Republic', shipping: 12.99, days: '7–14 business days' },
  { code: 'EC', name: 'Ecuador', shipping: 15.99, days: '10–18 business days' },
  { code: 'EG', name: 'Egypt', shipping: 18.99, days: '12–20 business days' },
  { code: 'SV', name: 'El Salvador', shipping: 13.99, days: '8–14 business days' },
  { code: 'EE', name: 'Estonia', shipping: 14.99, days: '9–16 business days' },
  { code: 'SZ', name: 'Eswatini', shipping: 21.99, days: '16–25 business days' },
  { code: 'FJ', name: 'Fiji', shipping: 19.99, days: '14–22 business days' },
  { code: 'FI', name: 'Finland', shipping: 13.99, days: '8–14 business days' },
  { code: 'FR', name: 'France', shipping: 12.99, days: '7–14 business days' },
  { code: 'GE', name: 'Georgia', shipping: 18.99, days: '12–20 business days' },
  { code: 'DE', name: 'Germany', shipping: 12.99, days: '7–14 business days' },
  { code: 'GR', name: 'Greece', shipping: 14.99, days: '9–16 business days' },
  { code: 'GD', name: 'Grenada', shipping: 14.99, days: '10–16 business days' },
  { code: 'GT', name: 'Guatemala', shipping: 13.99, days: '8–14 business days' },
  { code: 'GY', name: 'Guyana', shipping: 15.99, days: '10–18 business days' },
  { code: 'HN', name: 'Honduras', shipping: 13.99, days: '8–14 business days' },
  { code: 'HU', name: 'Hungary', shipping: 13.99, days: '8–14 business days' },
  { code: 'IS', name: 'Iceland', shipping: 15.99, days: '10–18 business days' },
  { code: 'IN', name: 'India', shipping: 14.99, days: '10–18 business days' },
  { code: 'ID', name: 'Indonesia', shipping: 16.99, days: '10–18 business days' },
  { code: 'IQ', name: 'Iraq', shipping: 21.99, days: '16–25 business days' },
  { code: 'IE', name: 'Ireland', shipping: 12.99, days: '7–14 business days' },
  { code: 'IL', name: 'Israel', shipping: 16.99, days: '10–18 business days' },
  { code: 'IT', name: 'Italy', shipping: 12.99, days: '7–14 business days' },
  { code: 'JM', name: 'Jamaica', shipping: 13.99, days: '8–14 business days' },
  { code: 'JP', name: 'Japan', shipping: 15.99, days: '7–14 business days' },
  { code: 'JO', name: 'Jordan', shipping: 18.99, days: '12–20 business days' },
  { code: 'KZ', name: 'Kazakhstan', shipping: 19.99, days: '14–22 business days' },
  { code: 'KW', name: 'Kuwait', shipping: 17.99, days: '10–18 business days' },
  { code: 'KG', name: 'Kyrgyzstan', shipping: 20.99, days: '16–25 business days' },
  { code: 'LV', name: 'Latvia', shipping: 14.99, days: '9–16 business days' },
  { code: 'LB', name: 'Lebanon', shipping: 18.99, days: '12–20 business days' },
  { code: 'LI', name: 'Liechtenstein', shipping: 14.99, days: '9–16 business days' },
  { code: 'LT', name: 'Lithuania', shipping: 14.99, days: '9–16 business days' },
  { code: 'LU', name: 'Luxembourg', shipping: 13.99, days: '8–14 business days' },
  { code: 'MY', name: 'Malaysia', shipping: 15.99, days: '10–18 business days' },
  { code: 'MV', name: 'Maldives', shipping: 19.99, days: '14–22 business days' },
  { code: 'MT', name: 'Malta', shipping: 14.99, days: '9–16 business days' },
  { code: 'MH', name: 'Marshall Islands', shipping: 22.99, days: '18–28 business days' },
  { code: 'MU', name: 'Mauritius', shipping: 20.99, days: '14–22 business days' },
  { code: 'MX', name: 'Mexico', shipping: 9.99, days: '5–10 business days' },
  { code: 'FM', name: 'Micronesia', shipping: 22.99, days: '18–28 business days' },
  { code: 'MD', name: 'Moldova', shipping: 17.99, days: '12–20 business days' },
  { code: 'MC', name: 'Monaco', shipping: 13.99, days: '8–14 business days' },
  { code: 'MN', name: 'Mongolia', shipping: 19.99, days: '14–22 business days' },
  { code: 'ME', name: 'Montenegro', shipping: 16.99, days: '12–20 business days' },
  { code: 'MA', name: 'Morocco', shipping: 17.99, days: '12–20 business days' },
  { code: 'NA', name: 'Namibia', shipping: 21.99, days: '16–25 business days' },
  { code: 'NR', name: 'Nauru', shipping: 24.99, days: '20–30 business days' },
  { code: 'NL', name: 'Netherlands', shipping: 12.99, days: '7–14 business days' },
  { code: 'NZ', name: 'New Zealand', shipping: 14.99, days: '8–14 business days' },
  { code: 'NI', name: 'Nicaragua', shipping: 13.99, days: '8–14 business days' },
  { code: 'MK', name: 'North Macedonia', shipping: 16.99, days: '12–20 business days' },
  { code: 'NO', name: 'Norway', shipping: 14.99, days: '9–16 business days' },
  { code: 'OM', name: 'Oman', shipping: 17.99, days: '10–18 business days' },
  { code: 'PW', name: 'Palau', shipping: 22.99, days: '18–28 business days' },
  { code: 'PA', name: 'Panama', shipping: 13.99, days: '8–14 business days' },
  { code: 'PY', name: 'Paraguay', shipping: 16.99, days: '12–20 business days' },
  { code: 'PE', name: 'Peru', shipping: 15.99, days: '10–18 business days' },
  { code: 'PH', name: 'Philippines', shipping: 18.99, days: '10–18 business days' },
  { code: 'PL', name: 'Poland', shipping: 13.99, days: '8–14 business days' },
  { code: 'PT', name: 'Portugal', shipping: 13.99, days: '8–14 business days' },
  { code: 'QA', name: 'Qatar', shipping: 17.99, days: '10–18 business days' },
  { code: 'RO', name: 'Romania', shipping: 14.99, days: '9–16 business days' },
  { code: 'RU', name: 'Russia', shipping: 18.99, days: '14–22 business days' },
  { code: 'KN', name: 'Saint Kitts and Nevis', shipping: 14.99, days: '10–16 business days' },
  { code: 'LC', name: 'Saint Lucia', shipping: 14.99, days: '10–16 business days' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', shipping: 14.99, days: '10–16 business days' },
  { code: 'SM', name: 'San Marino', shipping: 14.99, days: '9–16 business days' },
  { code: 'ST', name: 'São Tomé and Príncipe', shipping: 23.99, days: '18–28 business days' },
  { code: 'SA', name: 'Saudi Arabia', shipping: 17.99, days: '10–18 business days' },
  { code: 'RS', name: 'Serbia', shipping: 16.99, days: '12–20 business days' },
  { code: 'SC', name: 'Seychelles', shipping: 21.99, days: '16–25 business days' },
  { code: 'SG', name: 'Singapore', shipping: 13.99, days: '8–14 business days' },
  { code: 'SK', name: 'Slovakia', shipping: 13.99, days: '8–14 business days' },
  { code: 'SI', name: 'Slovenia', shipping: 13.99, days: '8–14 business days' },
  { code: 'ZA', name: 'South Africa', shipping: 18.99, days: '12–20 business days' },
  { code: 'ES', name: 'Spain', shipping: 12.99, days: '7–14 business days' },
  { code: 'LK', name: 'Sri Lanka', shipping: 18.99, days: '12–20 business days' },
  { code: 'SR', name: 'Suriname', shipping: 17.99, days: '12–20 business days' },
  { code: 'SE', name: 'Sweden', shipping: 13.99, days: '8–14 business days' },
  { code: 'CH', name: 'Switzerland', shipping: 13.99, days: '8–14 business days' },
  { code: 'TW', name: 'Taiwan', shipping: 15.99, days: '8–14 business days' },
  { code: 'TJ', name: 'Tajikistan', shipping: 21.99, days: '16–25 business days' },
  { code: 'TH', name: 'Thailand', shipping: 15.99, days: '10–18 business days' },
  { code: 'TT', name: 'Trinidad and Tobago', shipping: 14.99, days: '10–16 business days' },
  { code: 'TN', name: 'Tunisia', shipping: 18.99, days: '12–20 business days' },
  { code: 'TR', name: 'Turkey', shipping: 15.99, days: '10–18 business days' },
  { code: 'TV', name: 'Tuvalu', shipping: 24.99, days: '20–30 business days' },
  { code: 'UA', name: 'Ukraine', shipping: 16.99, days: '12–20 business days' },
  { code: 'AE', name: 'United Arab Emirates', shipping: 16.99, days: '10–18 business days' },
  { code: 'GB', name: 'United Kingdom', shipping: 12.99, days: '7–14 business days' },
  { code: 'UY', name: 'Uruguay', shipping: 16.99, days: '12–20 business days' },
  { code: 'UZ', name: 'Uzbekistan', shipping: 20.99, days: '16–25 business days' },
  { code: 'VN', name: 'Vietnam', shipping: 16.99, days: '10–18 business days' },
];
